// Opens the full Vendor Agreement in a print window. Shared by the vendor
// (their own copy) and admin (viewing what a vendor accepted). Pass `acceptance`
// to stamp the recorded click-wrap acceptance instead of a blank signature line.
import { COMPANY } from "@/config/company";
import {
  AGREEMENT_VERSION, AGREEMENT_EFFECTIVE, AGREEMENT_INTRO,
  AGREEMENT_SECTIONS, AGREEMENT_SCHEDULES,
} from "@/config/agreement";

const esc = (s) => String(s == null ? "" : s).replace(/[&<>]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;" }[c]));

export function openAgreementDoc(acceptance) {
  const w = window.open("", "_blank");
  if (!w) return;
  const sec = (h, arr) => `<h3>${esc(h)}</h3>` + arr.map((b) =>
    Array.isArray(b) ? `<ul>${b.map((li) => `<li>${esc(li)}</li>`).join("")}</ul>` : `<p>${esc(b)}</p>`).join("");
  const body =
    AGREEMENT_INTRO.parties.map((p) => `<p>${esc(p)}</p>`).join("") +
    AGREEMENT_SECTIONS.map((s) => sec(`${s.n}. ${s.title}`, s.body)).join("") +
    AGREEMENT_SCHEDULES.map((sc) =>
      `<h3>${esc(sc.title)}</h3><table>${sc.rows.map(([k, v]) => `<tr><td class="k">${esc(k)}</td><td>${esc(v)}</td></tr>`).join("")}</table>`).join("");

  // Signature block: a recorded acceptance for admin, else blank lines.
  const a = acceptance;
  const when = a?.accepted_at ? new Date(a.accepted_at).toLocaleString("en-IN") : "";
  const vendorBlock = a
    ? `<div class="accept"><p class="meta">Accepted electronically (click-wrap)</p>
        <p>Vendor: <b>${esc(a.store_name || "")}</b></p>
        <p>Signed by: <b>${esc(a.signer_name || "")}</b>${a.designation ? `, ${esc(a.designation)}` : ""}</p>
        <p>On: ${esc(when)} &nbsp;·&nbsp; Method: ${esc(a.method || "click")} &nbsp;·&nbsp; IP: ${esc(a.ip || "—")}</p>
        <p>Agreement version accepted: ${esc(a.version || AGREEMENT_VERSION)}</p></div>`
    : `<p>FOR THE VENDOR</p><p>Name: __________ Designation: __________ Signature: __________ Date: ______</p>`;

  w.document.write(`<!doctype html><html><head><meta charset="utf-8"><title>The Spotters Vendor Agreement v${esc(AGREEMENT_VERSION)}</title>
    <style>body{font-family:Georgia,serif;max-width:760px;margin:32px auto;padding:0 20px;color:#1a1a1a;line-height:1.5}
    h2{font-size:24px}h3{font-size:17px;margin-top:22px}p,li{font-size:13px}ul{padding-left:20px}
    table{border-collapse:collapse;width:100%;margin-top:8px}td{border:1px solid #ccc;padding:6px 8px;font-size:12px;vertical-align:top}
    td.k{width:34%;text-transform:uppercase;font-family:monospace;font-size:10px;letter-spacing:1px;color:#666}
    .meta{font-family:monospace;font-size:11px;color:#666;text-transform:uppercase;letter-spacing:1px}
    .accept{border:1px solid #111;padding:12px 16px;margin-top:8px}.accept p{margin:4px 0}</style></head>
    <body><h2>THE SPOTTERS — ${esc(AGREEMENT_INTRO.title)}</h2>
    <p class="meta">Version ${esc(AGREEMENT_VERSION)} · Effective ${esc(AGREEMENT_EFFECTIVE)}</p>${body}
    <div style="margin-top:40px"><p>FOR ${esc(COMPANY.legalName)} (The Spotters)</p><p>Name: __________ Designation: __________ Signature: __________ Date: ______</p>
    <br>${vendorBlock}</div>
    </body></html>`);
  w.document.close();
  w.focus();
}
